import { cn } from '@/lib/utils'

function Skeleton({ className, ...props }: React.ComponentProps<'div'>) {
  return (
    <div
      data-slot="skeleton"
      /* The analytics surfaces' quiet card wash, so a loading shape reads as
         "a card that hasn't arrived" rather than a control lighting up. */
      className={cn('bg-card/40 animate-pulse rounded-md', className)}
      {...props}
    />
  )
}

export { Skeleton }
